module.exports = __webpack_public_path__ + "static/media/loader.7f3c820a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/loader.svg
// module id = 157
// module chunks = 0